import { cloneElement, isValidElement, type ReactNode } from 'react';

import { LabelWithInfo } from '../ui/LabelWithInfo.js';

/**
 * Einheitenkomposition fuer Zahlenfelder (Phase 29, W-01/W-02).
 *
 * Die Einheit einer Zahleneingabe wurde bislang doppelt gepflegt --
 * `label="Wasserentnahme (m³)"` UND `suffix=" m³"` -- und lief deshalb an
 * manchen Stellen auseinander. Ausserdem ist der Suffix unsichtbar, solange
 * das Feld leer ist: genau dort soll die Einheit im Formular sichtbar
 * werden. `withUnit`/`unitSuffix` sind die einzige Stelle, an der aus einer
 * einzigen `unit`-Angabe Label-Zusatz und Eingabe-Suffix entstehen.
 */

/** Liefert die Einheit mit fuehrendem Leerzeichen, wie die bisherigen `suffix=" m³"`-Angaben. */
export function unitSuffix(unit: string): string {
  return ` ${unit}`;
}

/**
 * Haengt eine Einheit an ein Feldlabel an. Traegt sowohl reine String-Labels
 * als auch ein `LabelWithInfo`-Element als Label -- ohne Einheit wird nichts
 * erfunden, und `LabelWithInfo` bekommt die Einheit als eigenes Prop, damit
 * sie vor dem Info-Icon steht (Muster: "Wasserverbrauch (m³)").
 */
export function withUnit(label: ReactNode, unit: string | undefined): ReactNode {
  if (!unit || label === null || label === undefined) {
    return label;
  }

  if (isValidElement(label) && label.type === LabelWithInfo) {
    return cloneElement(label, { unit } as Partial<{ unit: string }>);
  }

  return (
    <>
      {label} ({unit})
    </>
  );
}
